import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { LoanInfoActions } from "../../models/cartable.model";
import { DoLoanAction } from "../../services/loan.service";
import BankInfoActionModal from "../modals/BankInfoActionModal";
import { v4 as uuid } from "uuid";

interface Props {
  loanInfoActions: any;
  setReload: (reload: string) => void;
}
const BankInfoActionButtons = ({ loanInfoActions, setReload }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState<
    Pick<
      LoanInfoActions,
      "fields" | "description" | "title" | "isCautionRequired"
    >
  >();
  const [command, setCommand] = useState("");
  const history = useHistory<any>();

  const id =
    history.location.state !== undefined
      ? history.location.state.id
      : window.sessionStorage.getItem("idFind") !== undefined
      ? window.sessionStorage.getItem("idFind")
      : null;
  const handleClick = (
    title: string,
    fields: any,
    description: string,
    isCautionRequired: boolean
  ) => {
    setOpenModal(true);
    setModalData({ fields, title, description, isCautionRequired });
  };

  const handleSubmitModal = (
    values: {
      name: string;
      value: string;
    }[]
  ) => {
    DoLoanActionMutate({
      referenceKey: String(id),
      command: command,
      fields: values,
    });
  };

  const { mutate: DoLoanActionMutate } = useMutation(DoLoanAction, {
    onSuccess: (data: { result: boolean }) => {
      if (data.result) {
        setOpenModal(false);
        setReload(uuid());
      }
    },
    onError: () => {},
  });

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {loanInfoActions?.map((item: any) => (
          <Button
            fullWidth
            variant="contained"
            type="submit"
            sx={{
              maxWidth: "200px",
            }}
            className={`btnForm ${
              item?.isCautionRequired ? "DangerDefault" : "SuccessDefault"
            }`}
            onClick={() => {
              handleClick(
                item.title,
                item.fields,
                item.description,
                item.isCautionRequired
              );
              setCommand(item.command);
            }}
          >
            {item?.title}
          </Button>
        ))}
      </Box>
      <BankInfoActionModal
        fields={modalData?.fields!}
        title={modalData?.title!}
        description={modalData?.description!}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleSubmitModal={handleSubmitModal}
        isCautionRequired={modalData?.isCautionRequired!}
      />
    </>
  );
};

export default BankInfoActionButtons;
